import formatNumber from "./formatNumber";

/**
 * This is used to format mileage with thousands separator.
 * @param value is the mileage raw value
 * @returns "0" if value is undefined or NaN, otherwise the formatted mileage
 */
export const formatMileage = (value) => {
  const int = parseInt(value, 10);

  if (isNaN(int)) {
    return "0";
  }

  return formatNumber(int);
};
